// Mock data for B2B Lead Generation Landing Page

export const companyInfo = {
  name: "iTMunch",
  tagline: "B2B Lead Generation Services",
  description: "Supercharge your sales pipeline with our expert B2B lead generation services. Get high-quality, verified leads that drive conversions and accelerate business growth.",
  email: "hello@itmunch.com",
  phone: "+1 (555) 123-4567",
  address: "123 Business Ave, Suite 500, San Francisco, CA 94102",
   logo: {
    header:
      "https://itmunch.com/wp-content/uploads/2024/01/itmunch-logo_black-02.png",
    footer:
      "https://itmunch.com/wp-content/uploads/2021/01/ITT-MUNCH_LOGO-4-1-1024x512_800x400.webp"
  }
};

export const heroContent = { 
  headline: "Transform Your Sales Pipeline with Quality B2B Leads",
  subheadline: "Our data-driven B2B lead generation services connect you with verified decision-makers actively searching for your solutions. Using AI-powered targeting, intent data, and strategic content syndication, we deliver high-quality, conversion-ready leads that accelerate pipeline growth, improve ROI, and help your sales team close deals faster.",
  primaryCTA: "Get Your Free Strategy Session",
  secondaryCTA: "See How It Works"
};

export const clientLogos = [
  { name: "TechCorp", id: 1 },
  { name: "CloudBase", id: 2 },
  { name: "DataFlow", id: 3 },
  { name: "SecureNet", id: 4 },
  { name: "SalesForce", id: 5 },
  { name: "MarketPro", id: 6 }
];

export const stats = [
  { value: 500, suffix: "+", label: "Successful Campaigns", id: 1 },
  { value: 150, suffix: "+", label: "Global Brands", id: 2 },
  { value: 98, suffix: "%", label: "Client Satisfaction", id: 3 },
  { value: 2, suffix: "M+", label: "Leads Generated", id: 4 }
];

export const whatIsLeadGen = {
  title: "What Is B2B Lead Generation?",
  content: `Lead generation is the lifeblood of any thriving business. It's the strategic process of identifying and attracting potential customers who have a genuine interest in your products or services.
For B2B companies, this means targeting key decision-makers within organizations, understanding their pain points, and demonstrating how your solution addresses their specific needs.
Effective B2B lead generation combines multiple channels including content marketing, email outreach, LinkedIn prospecting, paid advertising, and strategic partnerships to build a consistent pipeline of qualified prospects.`
};

export const benefits = [
  {
    id: 1,
    title: "Drive Sales to New Heights",
    description: "Access high-quality leads who are actively seeking solutions like yours. Our targeted campaigns connect you with prospects ready to convert, dramatically increasing your close rates.",
    icon: "TrendingUp"
  },
  {
    id: 2,
    title: "Maximize Your ROI",
    description: "Every marketing dollar counts. By focusing on qualified leads with genuine buying intent, your investment generates measurable returns and sustainable revenue growth.",
    icon: "DollarSign"
  },
  {
    id: 3,
    title: "Build Lasting Relationships",
    description: "Lead generation isn't just about numbers—it's about connections. We help you nurture relationships that turn prospects into loyal, long-term customers.",
    icon: "Users"
  },
  {
    id: 4,
    title: "Gain Competitive Advantage",
    description: "Stay ahead of your competition with a continuous flow of fresh leads. Our data-driven approach positions your brand at the forefront of your industry.",
    icon: "Award"
  },
  {
    id: 5,
    title: "Data-Powered Precision",
    description: "Make informed decisions with comprehensive analytics. Track every metric that matters and optimize campaigns for peak performance.",
    icon: "BarChart3"
  },
  {
    id: 6,
    title: "Scale With Confidence",
    description: "Whether you need 50 leads or 5,000, our infrastructure scales with your ambitions. Grow your pipeline without growing your headcount.",
    icon: "Rocket"
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: "Proprietary Technology Platform",
    description: "Our advanced AI-powered platform identifies high-intent prospects using behavioral signals, firmographic data, and predictive analytics.",
    icon: "Cpu"
  },
  {
    id: 2,
    title: "Extensive Network & Reach",
    description: "Access our network of 1,500+ premium publisher sites reaching over 1 million decision-makers monthly across all major industries.",
    icon: "Globe"
  },
  {
    id: 3,
    title: "Rapid Turnaround Time",
    description: "Start receiving qualified leads within 48 hours of campaign launch. We value your time and move at the speed of business.",
    icon: "Clock"
  },
  {
    id: 4,
    title: "Unmatched Industry Expertise",
    description: "With 10+ years in B2B lead generation, our team brings deep expertise across SaaS, manufacturing, finance, healthcare, and more.",
    icon: "Award"
  }
];

export const processSteps = [
  {
    id: 1,
    step: "01",
    title: "Understand Your Ideal Customer",
    description: "We start by diving deep into your target audience—their demographics, pain points, buying behaviors, and decision-making processes."
  },
  {
    id: 2,
    step: "02",
    title: "Acquire Qualified Leads",
    description: "Using our multi-channel approach and proprietary technology, we attract prospects with genuine interest in solutions like yours."
  },
  {
    id: 3,
    step: "03",
    title: "Score & Qualify Leads",
    description: "Not all leads are equal. We assess and score each prospect based on their likelihood to convert, ensuring quality over quantity."
  },
  {
    id: 4,
    step: "04",
    title: "Nurture & Engage",
    description: "Through personalized content and targeted communications, we guide qualified leads through the buyer's journey until they're ready to talk."
  },
  {
    id: 5,
    step: "05",
    title: "Deliver Sales-Ready Leads",
    description: "When prospects show clear buying intent, we seamlessly hand them off to your sales team—ready to close."
  }
];

export const testimonials = [
  {
    id: 1,
    quote: "We saw a 340% increase in qualified leads within the first quarter. Their data-driven approach transformed our entire sales pipeline.",
    author: "Sarah Chen",
    role: "VP of Marketing",
    company: "CloudTech Solutions",
    industry: "SaaS"
  },
  {
    id: 2,
    quote: "The quality of leads we receive is exceptional. These aren't just names—they're decision-makers actively looking for our solutions.",
    author: "Michael Rodriguez",
    role: "Global Sales Director",
    company: "SecureNet Industries",
    industry: "Cybersecurity"
  },
  {
    id: 3,
    quote: "Working with LeadPulse helped us overcome the challenge of connecting marketing spend with actual revenue. ROI is now crystal clear.",
    author: "Jennifer Walsh",
    role: "Chief Revenue Officer",
    company: "GreenEnergy Corp",
    industry: "Renewable Energy"
  },
  {
    id: 4,
    quote: "Their expertise in B2B lead generation is unmatched. We've opened numerous lucrative business opportunities we never knew existed.",
    author: "David Park",
    role: "CEO",
    company: "TechVenture Inc",
    industry: "Technology Services"
  }
];

export const faqs = [
  {
    id: 1,
    question: "What is B2B lead generation and how does it benefit my business?",
    answer: "B2B lead generation is the process of identifying and attracting potential business customers for your products or services. It benefits your business by creating a consistent pipeline of qualified prospects, reducing sales cycle time, improving conversion rates, and ultimately driving sustainable revenue growth."
  },
  {
    id: 2,
    question: "How quickly can I expect to see results?",
    answer: "Most clients begin receiving qualified leads within 48-72 hours of campaign launch. However, optimal results typically develop over 30-60 days as we refine targeting based on performance data. We provide regular reporting so you can track progress from day one."
  },
  {
    id: 3,
    question: "What industries do you specialize in?",
    answer: "We serve B2B companies across all major industries including technology/SaaS, manufacturing, financial services, healthcare, professional services, and more. Our customizable approach allows us to tailor strategies specifically for your market and target audience."
  },
  {
    id: 4,
    question: "How do you ensure lead quality?",
    answer: "Every lead goes through our rigorous qualification process including verification of contact information, company validation, intent signal analysis, and alignment with your ideal customer profile. We focus on quality over quantity—you'll only receive leads that match your specified criteria."
  },
  {
    id: 5,
    question: "What's included in your lead generation services?",
    answer: "Our comprehensive services include target audience research, multi-channel outreach campaigns, content syndication, email marketing, LinkedIn prospecting, lead scoring and qualification, CRM integration, and detailed performance analytics. Everything you need for a full-funnel lead generation strategy."
  },
  {
    id: 6,
    question: "Do you offer customized solutions for different business sizes?",
    answer: "Absolutely. Whether you're a startup looking for your first enterprise clients or a Fortune 500 company expanding into new markets, we create tailored programs that align with your specific goals, budget, and growth trajectory."
  }
];

export const ctaContent = {
  headline: "Ready to Fill Your Pipeline with Quality Leads?",
  subheadline: "Schedule a free strategy session and discover how we can accelerate your B2B growth.",
  buttonText: "Get Started Today"
};

export const countryCodes = [
  { code: "+93", country: "Afghanistan", flag: "🇦🇫" },
  { code: "+355", country: "Albania", flag: "🇦🇱" },
  { code: "+213", country: "Algeria", flag: "🇩🇿" },
  { code: "+376", country: "Andorra", flag: "🇦🇩" },
  { code: "+54", country: "Argentina", flag: "🇦🇷" },
  { code: "+61", country: "Australia", flag: "🇦🇺" },
  { code: "+43", country: "Austria", flag: "🇦🇹" },
  { code: "+973", country: "Bahrain", flag: "🇧🇭" },
  { code: "+880", country: "Bangladesh", flag: "🇧🇩" },
  { code: "+32", country: "Belgium", flag: "🇧🇪" },
  { code: "+55", country: "Brazil", flag: "🇧🇷" },
  { code: "+1", country: "Canada", flag: "🇨🇦" },
  { code: "+56", country: "Chile", flag: "🇨🇱" },
  { code: "+86", country: "China", flag: "🇨🇳" },
  { code: "+57", country: "Colombia", flag: "🇨🇴" },
  { code: "+506", country: "Costa Rica", flag: "🇨🇷" },
  { code: "+385", country: "Croatia", flag: "🇭🇷" },
  { code: "+357", country: "Cyprus", flag: "🇨🇾" },
  { code: "+420", country: "Czech Republic", flag: "🇨🇿" },
  { code: "+45", country: "Denmark", flag: "🇩🇰" },
  { code: "+20", country: "Egypt", flag: "🇪🇬" },
  { code: "+358", country: "Finland", flag: "🇫🇮" },
  { code: "+33", country: "France", flag: "🇫🇷" },
  { code: "+49", country: "Germany", flag: "🇩🇪" },
  { code: "+30", country: "Greece", flag: "🇬🇷" },
  { code: "+852", country: "Hong Kong", flag: "🇭🇰" },
  { code: "+36", country: "Hungary", flag: "🇭🇺" },
  { code: "+354", country: "Iceland", flag: "🇮🇸" },
  { code: "+91", country: "India", flag: "🇮🇳" },
  { code: "+62", country: "Indonesia", flag: "🇮🇩" },
  { code: "+353", country: "Ireland", flag: "🇮🇪" },
  { code: "+972", country: "Israel", flag: "🇮🇱" },
  { code: "+39", country: "Italy", flag: "🇮🇹" },
  { code: "+81", country: "Japan", flag: "🇯🇵" },
  { code: "+962", country: "Jordan", flag: "🇯🇴" },
  { code: "+254", country: "Kenya", flag: "🇰🇪" },
  { code: "+965", country: "Kuwait", flag: "🇰🇼" },
  { code: "+961", country: "Lebanon", flag: "🇱🇧" },
  { code: "+352", country: "Luxembourg", flag: "🇱🇺" },
  { code: "+60", country: "Malaysia", flag: "🇲🇾" },
  { code: "+52", country: "Mexico", flag: "🇲🇽" },
  { code: "+212", country: "Morocco", flag: "🇲🇦" },
  { code: "+31", country: "Netherlands", flag: "🇳🇱" },
  { code: "+64", country: "New Zealand", flag: "🇳🇿" },
  { code: "+234", country: "Nigeria", flag: "🇳🇬" },
  { code: "+47", country: "Norway", flag: "🇳🇴" },
  { code: "+968", country: "Oman", flag: "🇴🇲" },
  { code: "+92", country: "Pakistan", flag: "🇵🇰" },
  { code: "+51", country: "Peru", flag: "🇵🇪" },
  { code: "+63", country: "Philippines", flag: "🇵🇭" },
  { code: "+48", country: "Poland", flag: "🇵🇱" },
  { code: "+351", country: "Portugal", flag: "🇵🇹" },
  { code: "+974", country: "Qatar", flag: "🇶🇦" },
  { code: "+40", country: "Romania", flag: "🇷🇴" },
  { code: "+7", country: "Russia", flag: "🇷🇺" },
  { code: "+966", country: "Saudi Arabia", flag: "🇸🇦" },
  { code: "+65", country: "Singapore", flag: "🇸🇬" },
  { code: "+27", country: "South Africa", flag: "🇿🇦" },
  { code: "+82", country: "South Korea", flag: "🇰🇷" },
  { code: "+34", country: "Spain", flag: "🇪🇸" },
  { code: "+94", country: "Sri Lanka", flag: "🇱🇰" },
  { code: "+46", country: "Sweden", flag: "🇸🇪" },
  { code: "+41", country: "Switzerland", flag: "🇨🇭" },
  { code: "+886", country: "Taiwan", flag: "🇹🇼" },
  { code: "+66", country: "Thailand", flag: "🇹🇭" },
  { code: "+90", country: "Turkey", flag: "🇹🇷" },
  { code: "+971", country: "UAE", flag: "🇦🇪" },
  { code: "+44", country: "United Kingdom", flag: "🇬🇧" },
  { code: "+1", country: "United States", flag: "🇺🇸" },
  { code: "+58", country: "Venezuela", flag: "🇻🇪" },
  { code: "+84", country: "Vietnam", flag: "🇻🇳" }
];

export const footerLinks = {
  services: [
    { label: "Lead Generation", href: "https://itmunch.com/b2b-lead-generation-services/" },
    { label: "Content Syndication", href: "https://itmunch.com/b2b-content-syndication-services/" },
    { label: "Email Marketing", href: "https://itmunch.com/email-marketing-services/" },
    { label: "Enterprise SEO", href: "https://itmunch.com/enterprise-seo-services/" },
    { label: "Meta Advertising", href: "https://itmunch.com/meta-advertising-services/" },
    { label: "Programmatic Advertising", href: "https://itmunch.com/programmatic-advertising-services/" },
    { label: "AI Agent Services", href: "https://itmunch.com/ai-agent-for-sales/" },
    { label: "Backlink Services", href: "https://backlink.itmunch.com/" }
  ],
  company: [
    { label: "About Us", href: "https://itmunch.com/about-itmunch/" },
    { label: "Send Us Your Story", href: "https://itmunch.com/send-us-your-story/" },
    { label: "Contact", href: "https://itmunch.com/contact-us/" }
  ],
  partners: [
    { label: "Whitepapers Online", href: "https://whitepapersonline.com/" },
    { label: "Tools Metric", href: "https://toolsmetric.com/" }
  ],
  legal: [
    { label: "Privacy Policy", href: "https://itmunch.com/privacy-policy/" },
    { label: "Terms of Service", href: "https://itmunch.com/terms-conditions/" },
    { label: "Refund Policy", href: "https://itmunch.com/refund-policy/" }
  ]
};
